const IconVie = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="3.42847"
                width="24"
                height="17.1429"
                rx="3"
                fill="#F93939"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0001 14.4171L9.61149 15.6743L10.0686 13.0148L8.13721 11.1325L10.8069 10.744L12.0001 8.32568L13.1943 10.744L15.8629 11.1325L13.9315 13.0148L14.3886 15.6731"
                fill="#FFDA2C"
            />
        </svg>
    )
}
export default IconVie
